import { Login } from './pages/login';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Landing from './pages/landing';
import { Message } from './pages/message';
import NotFound from './pages/notFound';
import Layout from './pages/layout';
import { Proceedings } from './pages/proceedings';
import { ProceedingsForm } from './pages/proceedingsForm';
import { Agenda } from './pages/agenda';
import { Today } from './pages/today';
import { Logs } from './pages/logs';
import { LogsForm } from './pages/logsForm';
import { AgendaForm } from './pages/agendaForm';
import { Options } from './pages/options';
import { AuthProvider } from './context/context';
import ProtectedRoute from './components/protectedRoute';
import { Statistics } from './pages/statistics';

function App() {
  return (
    <>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Landing />} />
              <Route path="login" element={<Login />} />
              <Route path="mensaje" element={<ProtectedRoute component={Message}/>} />
              <Route path="expedientes" element={<ProtectedRoute component={Proceedings} />} />
              <Route path="expedientes/nuevo" element={<ProtectedRoute component={ProceedingsForm} />} />
              <Route
                path="expedientes/modificar"
                element={<ProtectedRoute component={ProceedingsForm} />}
              />
              <Route path="bitacora" element={<ProtectedRoute component={Logs} />} />
              <Route path="bitacora/modificar" element={<ProtectedRoute component={LogsForm} />} />
              <Route path="agenda" element={<ProtectedRoute component={Agenda} />} />
              <Route path="agenda/modificar" element={<ProtectedRoute component={AgendaForm} />} />
              <Route path="opciones" element={<ProtectedRoute component={Options} />} />
              <Route path="hoy" element={<ProtectedRoute component={Today} />} />
              <Route path="estadisticas" element={<ProtectedRoute component={Statistics} />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </>
  );
}

export default App;
